import React from "react";
import { SxProps } from "@mui/material";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import BusinessIcon from "@mui/icons-material/Business";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import CategoryIcon from "@mui/icons-material/Category";
import QuizIcon from "@mui/icons-material/Quiz";
import LanguageIcon from "@mui/icons-material/Language";
import InfoIcon from "@mui/icons-material/Info";
import color from "../Constants/colors";
import { getEntityIconByName } from "./getEntityIcon";
import { entityIcons } from "../Constants/entityIcons";

const iconMap: Record<string, React.ReactNode> = {
  companyName: <BusinessIcon fontSize="small" />,
  modelName: <ModelTrainingIcon fontSize="small" />,
  certificationCategory: <CategoryIcon fontSize="small" />,
  questionList: <QuizIcon fontSize="small" />,
  language: <LanguageIcon fontSize="small" />,
};

export const getIconForEvalInProgress = (key: string): React.ReactNode => {
  return iconMap[key] ?? <InfoIcon fontSize="small" />;
};

export const getFileIcon = (
  fileName: string,
  type: string = ""
): React.ReactNode => {
  const cleanFileName = fileName.replace(/\s*\(.*?\)\s*$/, "").toLowerCase();

  if (type === "kb")
    return <img src="/knowledgebase.png" alt="KB" width="60" height="60" />;
  if (cleanFileName.endsWith(".pdf"))
    return <img src="/pdf.png" alt="pdf" width="60" height="60" />;
  if ([".jpg", ".jpeg", ".png"].some((ext) => cleanFileName.endsWith(ext)))
    return <img src="/jpg.png" alt="jpg" width="60" height="60" />;
  if ([".doc", ".docx"].some((ext) => cleanFileName.endsWith(ext)))
    return <img src="/docx.png" alt="docx" width="60" height="60" />;
  if ([".ppt", ".pptx"].some((ext) => cleanFileName.endsWith(ext)))
    return (
      <SlideshowIcon
        sx={{ width: 60, height: 60, color: color.primary_dark }}
      />
    );
  if (
    [".mp3", ".wav", ".aac", ".ogg", ".aiff", ".wma"].some((ext) =>
      cleanFileName.endsWith(ext)
    )
  )
    return <img src="/mpr3.png" alt="mpr3" width="60" height="60" />;
  if (cleanFileName.endsWith(".csv"))
    return <img src="/csv.png" alt="csv" width="60" height="60" />;
  if (cleanFileName.endsWith(".txt"))
    return <img src="/txt.png" alt="txt" width="60" height="60" />;
  if ([".xls", ".xlsx"].some((ext) => cleanFileName.endsWith(ext)))
    return (
      <img
        src={`/xls${cleanFileName.endsWith("x") ? "x" : ""}.png`}
        alt="xls"
        width="60"
        height="60"
      />
    );

  return <img src="/article.png" alt="article" width="60" height="60" />;
};

export const getCompanyIconElement = (
  iconId: number,
  sx?: SxProps
): React.ReactElement | null => {
  const iconIndex = iconId - 1;
  const icon = entityIcons[iconIndex] ?? entityIcons[0];
  const iconComponent = getEntityIconByName(icon.iconName);

  if (!iconComponent) return null;

  const Element = iconComponent.type as React.ComponentType<
    Record<string, unknown>
  >;

  return <Element {...iconComponent.props} sx={sx} />;
};
